import React, { useEffect, useRef, useState } from 'react';
import titlestar from '../../../../assets/images/institute/title-star.svg';
import PaymentHeroMobile from '../../../../assets/images/institute/PaymentHeroMobile.png';
import plugin from '../../../../assets/images/institute/plugin.png';
import qrimage from '../../../../assets/images/institute/qrimage.png';
import moneytransfer from '../../../../assets/images/institute/moneytransfer.png';
import PaymentHero from '../../../../assets/images/institute/PaymentHero.png';
import bankImageP from '../../../../assets/images/institute/bankImageP.png';
import mobile from '../../../../assets/images/institute/mobile.png';
import note from '../../../../assets/images/institute/note.png';
import radio from '../../../../assets/images/institute/radio.png';
import rupee from '../../../../assets/images/institute/rupee.png';
import swipe from '../../../../assets/images/institute/swipe.png';
import wallet from '../../../../assets/images/institute/wallet.png';
import qrCode from '../../../../assets/images/institute/window.png';
import payment1Option1 from '../../../../assets/images/institute/payments/payment1Option1.png';
import payment1Option2 from '../../../../assets/images/institute/payments/payment1Option2.webp';
import payment1Option3 from '../../../../assets/images/institute/payments/payment1Option3.png';
import payment2Option1 from '../../../../assets/images/institute/payments/payment2Option1.png';
import payment2Option2 from '../../../../assets/images/institute/payments/payment2Option2.png';
import payment2Option3 from '../../../../assets/images/institute/payments/payment2Option3.png';
import payment3Option1 from '../../../../assets/images/institute/payments/payment3Option1.png';
import payment3Option2 from '../../../../assets/images/institute/payments/payment3Option2.png';
import payment3Option3 from '../../../../assets/images/institute/payments/payment3Option3.png';
import classes from "./Payments.module.scss";

import { useNavigate } from 'react-router-dom';
import { useOnScreen } from '../../../../hooks';
import { CustomButton, CustomExpandableStepper, CustomImageSlider, CustomImage } from '../../../atoms';

const Payments = () => {
    const navigate = useNavigate();

    const [selectedIdx, setSelectedIdx] = useState(1);
    const [selectedIdx1, setSelectedIdx1] = useState(1);
    const [selectedIdx2, setSelectedIdx2] = useState(1);

    const paymentOption1Interval = useRef(null);
    const paymentOption1Ref = useRef(null);
    const paymentOption2Interval = useRef(null);
    const paymentOption2Ref = useRef(null);
    const paymentOption3Interval = useRef(null);
    const paymentOption3Ref = useRef(null);

    const isPaymentOption1Visible = useOnScreen(paymentOption1Ref);
    const isPaymentOption2Visible = useOnScreen(paymentOption2Ref);
    const isPaymentOption3Visible = useOnScreen(paymentOption3Ref);

    const paymentModes = [rupee, radio, mobile, note, qrCode, wallet, bankImageP, swipe];
    const images = {
        option1: [payment1Option1, payment1Option2, payment1Option3],
        option2: [payment2Option1, payment2Option2, payment2Option3],
        option3: [payment3Option1, payment3Option2, payment3Option3]
    };

    const imagesMobile = {
        option1: [payment1Option1, payment1Option2, payment1Option3],
        option2: [payment2Option1, payment2Option2, payment2Option3],
        option3: [payment3Option1, payment3Option2, payment3Option3]
    };

    const paymentOptions = [
        {
            id: 'option1',
            title: 'PAYMENT OPTION 1',
            heading: 'Zero Cost EMI',
            description: 'Offer parents the convenience of paying fees in affordable monthly instalments with a quick 2 min sign-up!',
            ref: paymentOption1Ref,
            images: images.option1,
            imagesMobile: imagesMobile.option1,
            selectedIdx: selectedIdx,
            setSelectedIdx: setSelectedIdx,
            descriptionOrder: classes.ZeroCostEMI_Order1,
            imageOrder: classes.ZeroCostEMI_Order2,
            bgColor: classes.Gray_Color,
            gap: classes.Feature1_Gap,
            options: [
                {
                    title: 'Get the full year’s fee, upfront',
                    description: 'Receive upfront fees at the beginning of the academic year from GrayQuest, even if parents pay in parts.',
                },
                {
                    title: 'Boost institute’s cashflow',
                    description: 'Use the upfront cash flow for your growth and expansion plans.',
                },
                {
                    title: 'Digital and secure payments',
                    description: 'We have a simple, 2-min sign up process that’s completely digital.',
                },
            ]
        },
        {
            id: 'option2',
            title: 'PAYMENT OPTION 2',
            heading: 'Auto-Debit Subscription Payments',
            description: 'No more post-dates cheques! Collect fees as per due dates by automatically debiting them from the parent’s account!',
            ref: paymentOption2Ref,
            images: images.option2,
            imagesMobile: imagesMobile.option2,
            selectedIdx: selectedIdx1,
            setSelectedIdx: setSelectedIdx1,
            descriptionOrder: classes.AdSubscription_Order2,
            imageOrder: classes.AdSubscription_Order1,
            bgColor: classes.Yellow_Color,
            gap: classes.Feature2_Gap,
            options: [
                {
                    title: '50 sec sign up for auto-debit',
                    description: 'A simple process for parents to register for auto-debit and can use the same registration for upto 15 years.',
                },
                {
                    title: 'Send fee-related alerts and reminders',
                    description: 'With one click, send custom fee reminders and notifications to parents through WhatsApp, email and SMS.',
                },
                {
                    title: 'Eliminate fee follow-ups',
                    description: 'With auto-debit payments, fee will be auto-debited from parent’s account on due dates.',
                },
            ]
        },
        {
            id: 'option3',
            title: 'PAYMENT OPTION 3',
            heading: 'Online Payments',
            description: 'Parents can simply choose to pay online through a variety of online payment methods covered under RAPID.',
            ref: paymentOption3Ref,
            images: images.option3,
            imagesMobile: imagesMobile.option3,
            selectedIdx: selectedIdx2,
            setSelectedIdx: setSelectedIdx2,
            descriptionOrder: classes.OnlinePayments_Order1,
            imageOrder: classes.OnlinePayments_Order2,
            bgColor: classes.Gray_Color,
            gap: classes.Feature3_Gap,
            options: [
                {
                    title: 'Flexible fee-payment options',
                    description: 'Collect fees from parents via UPI, debit cards, net banking, credit cards, and wallets seamlessly!',
                },
                {
                    title: 'Auto-reconciliation of payments',
                    description: 'Use the upfront cash flow for your growth and expansion plans.',
                },
                {
                    title: 'Digital and secure payments',
                    description: 'We have a simple, 2-min sign up process that’s completely digital.',
                },
            ]
        },
    ];

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    const settings1 = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };


    const startInterval = (callback, intervalRef) => {
        intervalRef.current = setInterval(callback, 5000);
    };

    const stopInterval = (intervalRef) => {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
    };

    useEffect(() => {
        if (isPaymentOption1Visible) {
            !paymentOption1Interval.current &&
                startInterval(() => {


                    setSelectedIdx((oldIdx) => (oldIdx === 3 ? 1 : oldIdx + 1));
                }, paymentOption1Interval);
        } else {
            paymentOption1Interval.current &&
                stopInterval(paymentOption1Interval);
        }
    }, [isPaymentOption1Visible]);

    useEffect(() => {
        if (isPaymentOption2Visible) {
            !paymentOption2Interval.current &&
                startInterval(() => {

                    setSelectedIdx1((oldIdx) =>
                        oldIdx === 3 ? 1 : oldIdx + 1
                    );
                }, paymentOption2Interval);
        } else {
            paymentOption2Interval.current &&
                stopInterval(paymentOption2Interval);
        }
    }, [isPaymentOption2Visible]);

    useEffect(() => {
        if (isPaymentOption3Visible) {
            !paymentOption3Interval.current &&
                startInterval(() => {

                    setSelectedIdx2((oldIdx) =>
                        oldIdx === 3 ? 1 : oldIdx + 1
                    );
                }, paymentOption3Interval);
        } else {
            paymentOption3Interval.current &&
                stopInterval(paymentOption3Interval);
        }
    }, [isPaymentOption3Visible]);

    return (
        <div className={classes.Payments}>
            <div className={classes.Payments__HeaderSection}>
                <div className={classes.Payments__HeroImageWrapper}>
                    <CustomImage
                        title='payments'
                        images={[
                            {
                                media: '468',
                                src: PaymentHeroMobile,
                            }
                        ]}
                        lazy={false}
                        defaultImg={PaymentHero}
                    />
                </div>
                <div className={classes.Payments__Heading}>
                    <h2
                        className={classes.Payments__Header}>
                        All-in-one powerful fee payment solution
                    </h2>
                    <div className={classes.Payments__Description}>A first-of-its-kind, all in one payment platform specially designed for the education ecosystem.</div>
                    <div className={classes.Payments__Description}>RAPID enables educational institutes to collect fees in up to 8 different payment modes on one platform!</div>
                    <div className={classes.Payments__Description}>8+ payment modes on one platform</div>
                    <div className={classes.Payments__ModeWrapper}>
                        {paymentModes.map((item, index) => (
                            <div key={index} className={classes.Payments__Mode}>
                                <img src={item} alt={`mode-${index}`} />
                            </div>
                        ))}
                    </div>
                    <div>
                        <CustomButton
                            className={classes.Payments__ScheduleBtn}
                            onClick={() => navigate('/contact')}
                            text='Schedule demo'
                        >
                        </CustomButton>
                    </div>
                </div>
            </div>
            <div className={classes.Payments__FeatureSection}>
                <div>
                    {paymentOptions.map((item) => (
                        <section key={item.id} className={`${classes.FeatureWrapper} ${item.bgColor}`}>
                            <div className={`${classes.FeatureWrapper__Container} ${item.gap}`}>
                                <div className={`${classes.FeatureWrapper__LeftSection} ${item.descriptionOrder}`}>
                                    <div className={classes.FeatureWrapper__TitleWrapper}>
                                        <img className={classes.FeatureWrapper__Star} src={titlestar} alt="star icon" />
                                        <p className={classes.FeatureWrapper__Title}>{item.title}</p>
                                    </div>
                                    <div className={classes.FeatureWrapper__HeadingWrapper}>
                                        <h2 className={classes.FeatureWrapper__NormalText}>{item.heading}</h2>
                                    </div>
                                    <div className={classes.FeatureWrapper__DiscriptionWrapper}>
                                        <p>{item.description}</p>
                                    </div>
                                    <div className={classes.MobileView}>
                                        <CustomImageSlider item={item} />
                                    </div>
                                    <div className={`${classes.DesktopView} ${classes.Stepper_Wrapper}`}>
                                        <CustomExpandableStepper item={item} />
                                    </div>
                                </div>
                                <div className={`${classes.FeatureWrapper__RightSection} ${classes.DesktopView} ${item.imageOrder}`} ref={item.ref}>
                                    {item.selectedIdx >= 1 && (
                                        <div className={`${item.imageOrder}`}>
                                            <img
                                                className={classes.Feature_DesktopImg}
                                                src={images[item.id][item.selectedIdx - 1]}
                                                alt=''
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </section>
                    ))}
                </div>
            </div>
            <div className=' whyRadipContainer bg--blue'>
                <div className='container  '>
                    <h2 className='rapid_section__title-1 text--bold text--white'>
                        Why is RAPID so{' '}
                        <span className='text--pinkGradient text-spiral'>
                            easy to use?
                        </span>
                    </h2>
                    <div className='rapid-icons-box'>
                        <div className='rapid-icon-section'>
                            <img src={plugin} />
                            <h3 className='rapid-icon-text'>
                                <span className='text--white text--bold'>
                                    Instantly plugs
                                </span>{' '}
                                in with your existing softwares.
                            </h3>
                        </div>
                        <div className='rapid-icon-section'>
                            <img src={qrimage} />
                            <h3 className='rapid-icon-text'>
                                Also offers, on-campus fee collection via{' '}
                                <span className='text--white text--bold'>
                                    QR codes.
                                </span>
                            </h3>
                        </div>
                        <div className='rapid-icon-section'>
                            <img src={moneytransfer} />
                            <h3 className='rapid-icon-text'>
                                <span className='text--white text--bold'>
                                    Customise fee
                                </span>{' '}
                                collection experience for each student.
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Payments